import { styled } from '@mui/material/styles';
import ArgonBox from 'components/ArgonBox';

export default styled(ArgonBox)(({ theme, ownerState }) => {
  const { palette, borders, functions } = theme;
  const { borderRadius } = borders;
  const { pxToRem } = functions;

  return {
    display: 'inline-block',
    maxWidth: '100%',
    cursor: 'pointer',
    position: 'relative',
    '& .MuiInputBase-root': {
      borderRadius: borderRadius.md,
      border: `1px solid ${palette.grey[300]}`,
      '&:hover': {
        borderColor: palette.grey[400],
      },
      '&.Mui-focused': {
        borderColor: palette.grey[500],
      },
      cursor: 'pointer',
    },
    '& .MuiSelect-select': {
      padding: `${pxToRem(10)} ${pxToRem(14)}`,
      minHeight: 'auto',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiSvgIcon-root': {
      color: palette.grey[500],
    },
  };
});
